export const GET_GENERIC_MESSAGE_LIST = "GET_GENERIC_MESSAGE_LIST";
export const GET_GENERIC_MESSAGE_LIST_SUCCESS = "GET_GENERIC_MESSAGE_LIST_SUCCESS";

export const SAVE_GENERIC_MESSAGE_MASTER = "SAVE_GENERIC_MESSAGE_MASTER";
export const SAVE_GENERIC_MESSAGE_SUCCESS = "SAVE_GENERIC_MESSAGE_SUCCESS";

export const EDIT_GENERIC_MESSAGE = "EDIT_GENERIC_MESSAGE";
export const EDIT_GENERIC_MESSAGE_SUCCESS = "EDIT_GENERIC_MESSAGE_SUCCESS";

export const UPDATE_GENERIC_MESSAGE = "UPDATE_GENERIC_MESSAGE";
export const UPDATE_GENERIC_MESSAGE_SUCCESS = "UPDATE_GENERIC_MESSAGE_SUCCESS";

export const DELETE_GENERIC_MESSAGE = "DELETE_GENERIC_MESSAGE";
export const DELETE_GENERIC_MESSAGE_SUCCESS = "DELETE_GENERIC_MESSAGE_SUCCESS";

export const RESET_GENERIC_MESSAGE_STATE = "RESET_GENERIC_MESSAGE_STATE";


export const GENERIC_MESSAGE_ERROR_ACTION = "GENERIC_MESSAGE_ERROR_ACTION";
